import BaseComponent from '../../../general/js/base-component';
import app from "../../../general/js/app";
import createEvent from "../../../general/js/create-event";
import {onReady} from "./loadRecaptcha"

export const DEFAULT_RECAPTCHA_FIELD_NAME = 'g-recaptcha-response';
export const EVENT_AFTER_SUBMIT = 'recaptcha:afterSubmit';
export const EVENT_ON_ERROR = 'recaptcha:onError';

export default class RecaptchaComponent extends BaseComponent {
    constructor() {
        super(...arguments);
        this.captchaId = null;

        this.containerElement = this.refs.container;
        this.inputElement = this.refs.input;

        this.isLoading = true;

        this.onAfterSubmit = this.onAfterSubmit.bind(this);
        this.onError = this.onError.bind(this);

        if (this.containerElement && this.inputElement) {
            this.init = this.init.bind(this);
            this.successCallback = this.successCallback.bind(this);
            this.expiredCallback = this.expiredCallback.bind(this);

            onReady(this.init.bind(this));
        }
    }

    static getRequiredRefs() {
        return ['container', 'input'];
    }

    init(grecaptcha) {
        this.grecaptcha = grecaptcha;

        this.captchaId = grecaptcha.render(this.containerElement, {
            sitekey: app.getConfig('recaptchaKey'),
            callback: this.successCallback,
            "expired-callback": this.expiredCallback
        });
        this.isLoading = false;
        this.element.classList.remove('is-loading');
        this.inputElement.addEventListener(EVENT_AFTER_SUBMIT, this.onAfterSubmit);
        this.inputElement.addEventListener(EVENT_ON_ERROR, this.onError);
    }

    successCallback(response) {
        this.inputElement.value = response;
        this.inputElement.dispatchEvent(createEvent('input'));
        this.inputElement.dispatchEvent(createEvent('change'));
    }

    expiredCallback() {
        this.reset();
    }

    onAfterSubmit() {
        this.grecaptcha.reset(this.captchaId);
        this.reset();
    }

    onError() {
        this.grecaptcha.reset(this.captchaId);
        this.reset();
    }

    reset() {
        this.inputElement.value = '';
        this.inputElement.dispatchEvent(createEvent('input'));
        this.inputElement.dispatchEvent(createEvent('change'));
    }
}



// WEBPACK FOOTER //
// ./app/components/recaptcha/js/recaptcha.component.js